import {
  IPrioritySchedulerAction,
  PrioritySchedulerHeaderActionType,
} from "@miplatform/components";
import { AVAILABILITY_LOG_TYPE } from "@miplatform/constants";
import {
  mdiAccountOutline,
  mdiAccountPlusOutline,
  mdiArrowRightThin,
  mdiCalendarClock,
  mdiCancel,
  mdiClipboardAccountOutline,
} from "@mdi/js";

export const prioritySchedulerHeaderActions: IPrioritySchedulerAction[] = [
  {
    label: "View",
    icon: mdiArrowRightThin,
    type: PrioritySchedulerHeaderActionType.View,
    actions: [
      {
        label: "View More",
        icon: mdiArrowRightThin,
        type: PrioritySchedulerHeaderActionType.ViewMore,
      },
      {
        label: "View Profile",
        icon: mdiAccountOutline,
        type: PrioritySchedulerHeaderActionType.ViewProfile,
      },
    ],
  },
  {
    label: "Scheduling",
    icon: mdiCalendarClock,
    type: PrioritySchedulerHeaderActionType.Scheduling,
    actions: [
      {
        label: "Mark Inactive",
        icon: mdiClipboardAccountOutline,
        type: PrioritySchedulerHeaderActionType.MarkInactive,
      },
      {
        label: "Remove Inactive",
        icon: mdiClipboardAccountOutline,
        type: PrioritySchedulerHeaderActionType.RemoveInactive,
        getIsActionHidden: (user) =>
          !user.availabilityLog?.some(
            (log) => log.type === AVAILABILITY_LOG_TYPE.INACTIVE
          ),
      },
      {
        label: "Clear Schedule",
        icon: mdiCancel,
        iconColor: (theme) => theme.palette.error.main,
        type: PrioritySchedulerHeaderActionType.ClearSchedule,
      },
    ],
  },
  {
    label: "Add from Follow-Up",
    icon: mdiAccountPlusOutline,
    type: PrioritySchedulerHeaderActionType.AddFromFollowUp,
  },
];
